export type TLayoutsListParams = {
  page: number;
  pageSize: number;
  search: string;
  orderBy: string;
  orderType: 'asc' | 'desc';
};

export const layoutsKeys = {
  all: [{ module: 'layouts' }] as const,
  lists: () => [{ ...layoutsKeys.all[0], scope: 'list' }] as const,
  listsByOrganization: (organizationId: string) => [{ ...layoutsKeys.lists()[0], organizationId }] as const,
  list: (organizationId: string, params: TLayoutsListParams) =>
    [{ ...layoutsKeys.listsByOrganization(organizationId)[0], params }] as const,
  options: () => [{ ...layoutsKeys.all[0], scope: 'options' }] as const,
  optionsByOrganization: (organizationId: string) => [{ ...layoutsKeys.options()[0], organizationId }] as const,
  available: () => [{ ...layoutsKeys.all[0], scope: 'available' }] as const,
  availableByOrganization: (organizationId: string) => [{ ...layoutsKeys.available()[0], organizationId }] as const,
};
